import { Component } from '@angular/core';

@Component({
  selector: 'app-house-flat-page',
  templateUrl: './house-flat-page.component.html',
  styleUrl: './house-flat-page.component.scss'
})
export class HouseFlatPageComponent {

}
